import React from 'react';

import { Box } from '@mui/joy';

import { SharedSessionParticipant } from '../../services/types/api.generated';
import { Participant } from '../../types/voice-chat-provider';
import { LiveLineData, MarkerData, MapType } from '../Mapbox/mapTypes';
import { FitMode } from '../VideoScaler';
import { AgentStatus } from './types';
import MainViewSwitcher from './MainViewSwitcher';
import SettingsAccordion from './SettingsAccordion';
import VideoPiPContainer from './VideoPiPContainer';

interface CrewViewContentProps {
  containerRef: React.RefObject<HTMLDivElement | null>;
  isFullscreenVideo: boolean;
  liveLine: LiveLineData;
  markerImages: { [id: string]: MarkerData };
  mapRef: React.MutableRefObject<MapType | null>;
  videoUrl: string;
  initialZoom: number;
  onChangeView: () => void;
  sessionId: string;
  participantId: string;
  deviceUuid: string;
  onlineParticipants: SharedSessionParticipant[];
  viewerCount: number;
  microphoneEnabled: boolean;
  isVoiceChatConnected: boolean;
  isVoiceChatConnecting: boolean;
  onToggleMicrophone: () => Promise<void>;
  onToggleVoiceChat: () => Promise<void>;
  onSetMicrophone: (enabled: boolean) => Promise<void>;
  voiceChatParticipants: Array<{ id: string; name: string; isLocal?: boolean }>;
  activeSpeakers: Participant[];
  fitMode?: FitMode;
  onFitModeChange?: (mode: FitMode) => void;
  agentStatus: AgentStatus;
  setAgentStatus: (status: AgentStatus) => void;
}

const CrewViewContent: React.FC<CrewViewContentProps> = ({
  containerRef,
  isFullscreenVideo,
  liveLine,
  markerImages,
  mapRef,
  videoUrl,
  initialZoom,
  onChangeView,
  sessionId,
  participantId,
  deviceUuid,
  onlineParticipants,
  viewerCount,
  microphoneEnabled,
  isVoiceChatConnected,
  isVoiceChatConnecting,
  onToggleMicrophone,
  onToggleVoiceChat,
  onSetMicrophone,
  voiceChatParticipants,
  activeSpeakers,
  fitMode,
  onFitModeChange,
  agentStatus,
  setAgentStatus
}) => {
  return (
    <Box ref={containerRef} className='flex-1 relative'>
      <SettingsAccordion
        subTitle={sessionId}
        participants={onlineParticipants}
        sessionId={sessionId}
        participantId={participantId}
        deviceUuid={deviceUuid}
        viewerCount={viewerCount}
        microphoneEnabled={microphoneEnabled}
        isVoiceChatConnected={isVoiceChatConnected}
        isVoiceChatConnecting={isVoiceChatConnecting}
        onToggleMicrophone={onToggleMicrophone}
        onToggleVoiceChat={onToggleVoiceChat}
        voiceChatParticipants={voiceChatParticipants}
        activeSpeakers={activeSpeakers}
        agentStatus={agentStatus}
        setAgentStatus={setAgentStatus}
        droneUuids={[deviceUuid]}
        onSetMicrophone={onSetMicrophone}
      />

      <MainViewSwitcher
        isFullscreenVideo={isFullscreenVideo}
        liveLine={liveLine}
        markerImages={markerImages}
        mapRef={mapRef}
        videoUrl={videoUrl}
        initialZoom={initialZoom}
        fitMode={fitMode}
        onFitModeChange={onFitModeChange}
      />

      <VideoPiPContainer
        isFullscreenVideo={isFullscreenVideo}
        liveLine={liveLine}
        markerImages={markerImages}
        mapRef={mapRef}
        videoUrl={videoUrl}
        onChangeView={onChangeView}
        initialZoom={initialZoom}
        fitMode={fitMode}
        onFitModeChange={onFitModeChange}
      />
    </Box>
  );
};

export default CrewViewContent;
